/* BIG SHOP — Busca inteligente (tolerancia a erro de digitacao)
   Corrige o termo pesquisado usando:
   1) uma lista manual editavel no editor (ex.: "catar link = starlink");
   2) tolerancia automatica a acentos, maiusculas e plural;
   3) distancia de edicao (Levenshtein) contra os termos conhecidos da lista,
      pegando erros proximos como "starlnk" -> "starlink".
   Comportamento (opcao A): quando a busca nao acha nada, redireciona para o
   termo corrigido e mostra o aviso "Mostrando resultados para X". */
(function () {
  if (window.__bsFuzzyInit) return;
  window.__bsFuzzyInit = true;

  /* normaliza: minusculo, sem acento, espacos colapsados */
  function norm(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* le a lista do editor: cada linha "errado = certo" */
  function parseCorrections(text) {
    var map = {};
    (text || '').split('\n').forEach(function (line) {
      var idx = line.indexOf('=');
      if (idx === -1) return;
      var from = norm(line.slice(0, idx));
      var to = line.slice(idx + 1).trim();
      if (from && to) map[from] = to;
    });
    return map;
  }

  var CORR = parseCorrections(window.__bsSearchCorrections);

  /* dicionario para a busca aproximada: chaves (erros) + alvos (certos) */
  var DICT = [];
  (function () {
    var seen = {};
    Object.keys(CORR).forEach(function (from) {
      var to = CORR[from];
      DICT.push({ key: from, out: to });
      var nt = norm(to);
      if (!seen[nt]) {
        seen[nt] = true;
        DICT.push({ key: nt, out: to });
      }
    });
  })();

  function levenshtein(a, b) {
    if (a === b) return 0;
    var al = a.length, bl = b.length;
    if (al === 0) return bl;
    if (bl === 0) return al;
    var prev = [], i, j;
    for (j = 0; j <= bl; j++) prev[j] = j;
    for (i = 1; i <= al; i++) {
      var cur = [i];
      for (j = 1; j <= bl; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
      }
      prev = cur;
    }
    return prev[bl];
  }

  /* correcao exata (lista + plural) — usada tambem pela busca preditiva */
  function correctExact(term) {
    var q = norm(term);
    if (!q) return null;
    if (CORR[q]) return CORR[q];
    if (q.charAt(q.length - 1) === 's' && CORR[q.slice(0, -1)]) return CORR[q.slice(0, -1)];
    if (CORR[q + 's']) return CORR[q + 's'];
    return null;
  }

  /* correcao completa (exata + aproximada) — usada na pagina de resultados */
  function correctFuzzy(term) {
    var exact = correctExact(term);
    if (exact) return exact;

    var q = norm(term);
    if (q.length < 3 || !DICT.length) return null;

    var best = null, bestD = 99;
    var maxD = q.length <= 5 ? 1 : 2;
    DICT.forEach(function (entry) {
      var d = levenshtein(q, entry.key);
      if (d < bestD) { bestD = d; best = entry; }
    });
    if (best && bestD <= maxD) return best.out;
    return null;
  }

  /* expoe a correcao exata para a busca preditiva */
  window.__bsCorrectExact = correctExact;

  /* ---- Pagina de resultados: aviso + auto-correcao (opcao A) ---- */
  function initResultsPage() {
    var anchor = document.querySelector('[data-bs-search-count]');
    if (!anchor) return;

    var count = parseInt(anchor.getAttribute('data-bs-search-count'), 10) || 0;
    var term = anchor.getAttribute('data-bs-search-term') || '';
    var params = new URLSearchParams(window.location.search);

    if (params.get('bs_nocorrect') === '1') return;

    var from = params.get('bs_from');
    if (from) {
      showBanner(term, from);
      return;
    }

    if (count === 0 && term) {
      var fixed = correctFuzzy(term);
      if (fixed && norm(fixed) !== norm(term)) {
        var u = new URL(window.location.href);
        u.searchParams.set('q', fixed);
        u.searchParams.set('bs_from', term);
        window.location.replace(u.toString());
      }
    }
  }

  function showBanner(shownTerm, originalTerm) {
    var host = document.querySelector('[data-bs-correction-banner]');
    if (!host) return;

    var origUrl = new URL(window.location.href);
    origUrl.searchParams.set('q', originalTerm);
    origUrl.searchParams.set('bs_nocorrect', '1');
    origUrl.searchParams.delete('bs_from');

    var msg = document.createElement('p');
    msg.className = 'bs-correction__msg';
    msg.innerHTML =
      'Mostrando resultados para <strong>' + escapeHtml(shownTerm) + '</strong>. ' +
      'Pesquisar em vez disso por <a class="bs-correction__link" href="' +
      escapeHtml(origUrl.toString()) + '">' + escapeHtml(originalTerm) + '</a>?';

    host.appendChild(msg);
  }

  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initResultsPage);
  } else {
    initResultsPage();
  }
})();
